import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCsO7ejUHmZ0rB0OODm_t--kU9jHNmmelw",
  authDomain: "get-squeakyleads.firebaseapp.com",
  projectId: "get-squeakyleads",
  storageBucket: "get-squeakyleads.firebasestorage.app",
  messagingSenderId: "615693961311",
  appId: "1:615693961311:web:513bbb981b2612bcecf3ea",
  measurementId: "G-3T1EDQKBK9"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { app, analytics, db };
